import * as React from "react";
import { useStableCallback } from "../../utils/useStableCallback.js";
import { useAnimationsFinished } from "./useAnimationsFinished.js";
function useOpenChangeComplete(parameters) {
  const {
    enabled = true,
    open,
    ref,
    batch = false,
    onComplete: onCompleteParam
  } = parameters;
  const onComplete = useStableCallback(onCompleteParam);
  const runOnceAnimationsFinish = useAnimationsFinished(ref, open, batch);
  React.useEffect(() => {
    if (!enabled) {
      return void 0;
    }
    const abortController = new AbortController();
    runOnceAnimationsFinish(onComplete, abortController.signal);
    return () => {
      abortController.abort();
    };
  }, [enabled, open, onComplete, runOnceAnimationsFinish]);
}
export {
  useOpenChangeComplete
};
//# sourceMappingURL=useOpenChangeComplete.js.map
